import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const headlineLines = ['25 Years of', 'Architecture Built on', 'Discipline and Design'];
const heroImages = ['https://cdn.magicpatterns.com/uploads/8FaFzJH9k4LW7FBUtRvEvQ/Screenshot_2026-07-03_at_1.03.19_PM.png', 'https://cdn.magicpatterns.com/uploads/a9sMTvZYHZm7jC4bkYAQxJ/Screenshot_2026-07-03_at_1.04.01_PM.png', 'https://cdn.magicpatterns.com/uploads/2WzHDfceQGZBDvnpc3Lfbk/Screenshot_2026-07-03_at_1.04.24_PM.png', 'https://cdn.magicpatterns.com/uploads/iUYb5GQtGFo3KtJXgKryeC/Screenshot_2026-07-03_at_1.05.04_PM.png'];
const SLIDE_DURATION = 7000;
export function HeroSection() {
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    const id = setInterval(() => {
      setCurrent(prev => (prev + 1) % heroImages.length);
    }, SLIDE_DURATION);
    return () => clearInterval(id);
  }, []);
  return <section className="relative h-screen w-full flex items-center overflow-hidden bg-primary" data-id="element-95">
      {/* Background slideshow: slow crossfade + per-image Ken Burns zoom */}
      <div className="absolute inset-0 z-0" data-id="element-96">
        <AnimatePresence data-id="element-97">
          <motion.div key={current} initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          opacity: {
            duration: 2.5,
            ease: 'easeInOut'
          }
        }} className="absolute inset-0" data-id="element-98">
            <motion.div initial={{
            scale: 1
          }} animate={{
            scale: 1.08
          }} transition={{
            duration: SLIDE_DURATION / 1000 + 4,
            ease: 'easeOut'
          }} className="absolute inset-0" style={{
            backgroundImage: `url("${heroImages[current]}")`,
            backgroundPosition: 'center',
            backgroundSize: 'cover'
          }} data-id="element-99" />
          </motion.div>
        </AnimatePresence>
        <div className="absolute inset-0 bg-black/55" data-id="element-100" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-black/30" data-id="element-101" />
      </div>

      {/* Content - left aligned, bottom positioned */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 w-full text-center md:text-left" data-id="element-102">
        {/* Staggered headline */}
        <div className="mb-8 md:mb-10 overflow-hidden" data-id="element-103">
          {headlineLines.map((line, index) => <div key={index} className="overflow-hidden py-1 md:py-3" data-id="element-104">
              <motion.h1 initial={{
            y: '100%',
            opacity: 0
          }} animate={{
            y: '0%',
            opacity: 1
          }} transition={{
            duration: 1,
            delay: 0.3 + index * 0.15,
            ease: [0.16, 1, 0.3, 1]
          }} className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-light text-white leading-[1.3] tracking-tight" data-id="element-105">
                {line}
              </motion.h1>
            </div>)}
        </div>

        {/* Accent line draw */}
        <motion.div initial={{
        scaleX: 0
      }} animate={{
        scaleX: 1
      }} transition={{
        duration: 1.2,
        delay: 0.9,
        ease: [0.16, 1, 0.3, 1]
      }} className="w-24 h-[2px] bg-accent mb-8 origin-center md:origin-left mx-auto md:mx-0" data-id="element-106" />

        {/* Tagline slides in */}
        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 1.1,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-white/60 max-w-lg mx-auto md:mx-0 text-lg md:text-xl font-light leading-relaxed" data-id="element-107">
          Designing spaces that are practical, enduring, and built to perform
        </motion.p>

        {/* Scroll indicator - directly under the tagline */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 1.8
      }} className="mt-10 flex items-center gap-3 justify-center md:justify-start" data-id="element-108">
          <span className="text-white text-xs tracking-widest uppercase font-light" data-id="element-109">
            Discover More
          </span>
          <motion.div animate={{
          y: [0, 6, 0]
        }} transition={{
          repeat: Infinity,
          duration: 2,
          ease: 'easeInOut'
        }} data-id="element-110">
            <ChevronDown className="text-accent w-5 h-5" data-id="element-111" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}